import React from 'react';
import { motion } from 'framer-motion';
import { SmartphoneIcon, LaptopIcon, TabletIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { IMAGES } from '../data/content';
export function ProductPreview() {
  return <section className="w-full bg-beige/50 py-16 sm:py-24" data-id="element-156" data-mp="11vxkui76tr2v">
      <div className="mx-auto max-w-5xl px-5" data-id="element-157" data-mp="16tgypgzz41ua">
        <SectionHeading eyebrow="Un vistazo por dentro" title="Así se ve tu guía de viandas" subtitle="Un diseño claro y prolijo, pensado para consultar rápido cualquier receta." data-id="element-158" data-mp="1brs85qmcwabz" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="mt-12" data-id="element-159" data-mp="1lh20n7l43v0m">
          <img src={IMAGES.ebookPreview} alt="Vista previa del ebook de recetas en tablet y celular" className="mx-auto w-full rounded-3xl object-cover shadow-2xl" data-id="element-160" data-mp="1ujtefe1gn2vf" />
        </motion.div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm font-bold text-green-deep" data-id="element-161" data-mp="tog098x47gbp">
          <span className="inline-flex items-center gap-2" data-id="element-162" data-mp="kpm41jnp4ryo">
            <SmartphoneIcon className="h-5 w-5 text-green-brand" data-id="element-163" data-mp="ks8d5nq8jfj0" /> Celular
          </span>
          <span className="inline-flex items-center gap-2" data-id="element-164" data-mp="fsvp4znmo2eu">
            <TabletIcon className="h-5 w-5 text-green-brand" data-id="element-165" data-mp="1chjxt5dgedbl" /> Tablet
          </span>
          <span className="inline-flex items-center gap-2" data-id="element-166" data-mp="18f6rofusodea">
            <LaptopIcon className="h-5 w-5 text-green-brand" data-id="element-167" data-mp="18ht5gx8a3p4y" /> Computadora
          </span>
        </div>
      </div>
    </section>;
}